import React from "react";
import {Flex, Table, ConfigProvider} from "antd";
import PrimaryButton from "../button/primarybutton";
const columns = [
  {
    title: "Activity Type",
    width: 40,
    dataIndex: "activityType",
    key: "1",
  },
  {
    title: "Device",
    width: 50,
    dataIndex: "device",
    key: "2",
  },
  {
    title: "Date / Time",
    dataIndex: "dateTime",
    key: "3",
    sorter: true,
    width: 50,
  },
  {
    title: "Platform",
    dataIndex: "platform",
    key: "4",
    width: 40,
  },
  {
    title: "IP Address",
    dataIndex: "IPaddress",
    sorter: true,
    // render: (name) => `${name.first} ${name.last}`,
    key: "5",
    width: 40,
  },
  {
    title: "Action",
    key: "17",
    fixed: "right",
    width: 30,
    render: () => (
      <PrimaryButton
            style={{
              width: "100px",
              height: "25px",
              fontSize: "12px",
              background: "#f5a524",
              borderRadius: "4px",
            }}
            text={"Headers"}
          />
    ),
  },
];
const data = [];
for (let i = 1; i < 50; i++) {
  data.push({
    key: i,
    activityType: `Photo Request sent`,
    device: `Linux; Android 10; K`,
    dateTime: <p>15 Jul 2024 <br/>11:21:11</p>,
    platform: `Google Chrome`,
    IPaddress: <p>27.147.204.217 <br/>(Bangladesh)</p>,
  });
}
export default function ActivityLogsComp() {

  return (
    <>
      <div className="w-full flex flex-col justify-between">
        <div className="w-full">
          <ConfigProvider
            theme={{
              components: {
                Table: {
                  headerBg: "#310048",
                  headerColor: "#ffffff",
                  cellFontSize: "14px",
                  headerSortHoverBg: "#310048",
                  headerSortActiveBg: "",
                },
              },
            }}
          >
            <Flex gap="middle" vertical>
              <Table
                className="user-list"
                bordered
                columns={columns}
                dataSource={data}
                pagination={{
                  pageSize: 10,
                }}
                scroll={{
                  x: 1000,
                  y: 800,
                }}
              />
            </Flex>
          </ConfigProvider>
        </div>
      </div>
    </>
  );
}
